export const DASHBOARD = "dashboard";
export const MANAGE_BRANCHES = "manage-branches";
export const MY_BRANCH = "my-branch";
export const SERVICE_REQUESTS = "service-requests";
export const SERVICES = "services";
export const SCHEDULE = "schedule";
export const BUSINESS_PROFILE = "business-profile";
export const MANAGERS = "managers";
export const ANALYTICS = "analytics";
